import React, {useContext} from "react";
import './ExitGameConfirmDialog.css'
import {ThemeContext} from "../../../../../providers/themeContext/theme-context.tsx";
import CustomPopup from "../../../../../components/CustomPopup";

type ExitGameConfirmDialogProps = {
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

// 中途退出游戏时的弹窗提示
const ExitGameConfirmDialog:React.FC<ExitGameConfirmDialogProps> = ({isOpen, onConfirm, onCancel}) => {
    // 主题全局管理器
    const {imgUrls} = useContext(ThemeContext);

  return (
      <CustomPopup isOpen={isOpen} onClose={onCancel}>
       <div className="exit-game-confirm-dialog-container">
           <div className="exit-close-dialog-title my-roboto-medium">Reset Stats</div>
           <img onClick={onCancel} className="exit-close-btn" src={imgUrls.closerBtnGreyUrl} alt="pic" />
           <div className="exit-game-confirm-dialog-content-container">
               <div className="my-roboto-regular margin-top-17">Are you sure you want to exit?</div>
               <div className="my-roboto-regular margin-top-13">Exiting will reset your current game.</div>
           </div>
           <div onClick={onConfirm} className="exit-game-dialog-confirm-btn my-roboto-medium">Confirm</div>
           <div onClick={onCancel} className="exit-game-dialog-cancel-btn my-roboto-regular">Cancel</div>
           <img className="common-dialog-embellish-bg-left-top" src={imgUrls.leftTopBgDialogUrl} alt="pic"/>
           <img className="common-dialog-embellish-bg-right-bottom" src={imgUrls.rightBottomBgDialogUrl} alt="pic"/>
       </div>


      </CustomPopup>
  )
}

export  default ExitGameConfirmDialog;